// Tour Options Repeater JavaScript
// Manages dynamic addition and removal of tour options in the form

$(document).on('turbolinks:load', function() {
  
  // Initialize counter for new options
  let optionCounter = 0;
  
  // Function to initialize tiered prices for a specific option
  function initializeTieredPricesForOption(optionContainer) {
    const container = optionContainer.find('.tiered-prices-container');
    const hiddenField = optionContainer.find('.tiered-prices-json');
    
    // Add tier price button handler
    optionContainer.find('.add-tier-price-btn').off('click').on('click', function(e) {
      e.preventDefault();
      const tierTemplate = `
        <div class="tier-price-row mb-2">
          <div class="row">
            <div class="col-4">
              <input type="number" class="form-control tier-participants" placeholder="Participants" min="1" max="20">
            </div>
            <div class="col-6">
              <input type="number" class="form-control tier-price" placeholder="Price (COP)" min="0" step="1000">
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-sm btn-danger remove-tier-btn">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      `;
      container.append(tierTemplate);
      updateTieredPricesJson(optionContainer);
    });
    
    // Remove tier price handler
    optionContainer.on('click', '.remove-tier-btn', function() {
      $(this).closest('.tier-price-row').remove();
      updateTieredPricesJson(optionContainer);
    });
    
    // Update JSON on input change
    optionContainer.on('input', '.tier-participants, .tier-price', function() {
      updateTieredPricesJson(optionContainer);
    });
  }
  
  // Function to update the hidden JSON field with tiered prices
  function updateTieredPricesJson(optionContainer) {
    const container = optionContainer.find('.tiered-prices-container');
    const hiddenField = optionContainer.find('.tiered-prices-json');
    const tiers = [];
    
    container.find('.tier-price-row').each(function() {
      const participants = parseInt($(this).find('.tier-participants').val()) || 0;
      const price = parseFloat($(this).find('.tier-price').val()) || 0;
      
      if (participants > 0 && price > 0) {
        tiers.push({ participants: participants, price: price });
      }
    });
    
    // Sort by participants
    tiers.sort((a, b) => a.participants - b.participants);
    
    hiddenField.val(JSON.stringify(tiers));
  }
  
  // Toggle tour options section based on checkbox
  $('#tour_has_options').on('change', function() {
    const optionsSection = $('#tour-options-section');
    
    if ($(this).is(':checked')) {
      optionsSection.removeClass('d-none').slideDown();
      
      // If no options exist, add one
      if ($('.tour-option-item').length === 0) {
        $('#add-tour-option').click();
      }
    } else {
      optionsSection.slideUp(function() {
        $(this).addClass('d-none');
      });
    }
  });
  
  // Add new tour option
  $('#add-tour-option').on('click', function(e) {
    e.preventDefault();
    
    const timestamp = new Date().getTime();
    const template = `
      <div class="tour-option-item card mb-3" data-index="${timestamp}">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Option #<span class="option-number"></span></h5>
          <button type="button" class="btn btn-sm btn-danger remove-option-btn">
            <i class="fas fa-times"></i> Remove
          </button>
        </div>
        <div class="card-body">
          <input type="hidden" name="tour[tour_options_attributes][${timestamp}][position]" value="" class="option-position">
          
          <!-- Title Fields -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label">Title (English) <span class="text-danger">*</span></label>
              <input type="text" 
                     name="tour[tour_options_attributes][${timestamp}][title_en]" 
                     class="form-control" 
                     placeholder="e.g. Party Entry | 8:30 - 16:00"
                     required>
            </div>
            <div class="col-md-6">
              <label class="form-label">Title (Spanish) <span class="text-danger">*</span></label>
              <input type="text" 
                     name="tour[tour_options_attributes][${timestamp}][title_es]" 
                     class="form-control" 
                     placeholder="e.g. Entrada para la fiesta | 8:30 - 16:00"
                     required>
            </div>
          </div>
          
          <!-- Description Fields -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label">Description (English)</label>
              <textarea name="tour[tour_options_attributes][${timestamp}][description_en]" 
                        class="form-control" 
                        rows="3"
                        placeholder="Describe what's included in this option..."></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label">Description (Spanish)</label>
              <textarea name="tour[tour_options_attributes][${timestamp}][description_es]" 
                        class="form-control" 
                        rows="3"
                        placeholder="Describe qué incluye esta opción..."></textarea>
            </div>
          </div>
          
          <!-- Schedule Field -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label">Schedule</label>
              <input type="text" 
                     name="tour[tour_options_attributes][${timestamp}][schedule]" 
                     class="form-control" 
                     placeholder="e.g. 8:30 - 16:00">
            </div>
            <div class="col-md-6">
              <label class="form-label">Status</label>
              <div class="form-check form-switch mt-2">
                <input class="form-check-input" 
                       type="checkbox" 
                       name="tour[tour_options_attributes][${timestamp}][is_active]" 
                       value="1" 
                       checked>
                <label class="form-check-label">Active</label>
              </div>
            </div>
          </div>
          
          <!-- Tiered Prices Section -->
          <div class="tiered-prices-section">
            <h6 class="mb-3">Tiered Prices</h6>
            <input type="hidden" 
                   name="tour[tour_options_attributes][${timestamp}][tiered_prices]" 
                   class="tiered-prices-json" 
                   value="[]">
            
            <div class="tiered-prices-container mb-3"></div>
            
            <button type="button" class="btn btn-sm btn-secondary add-tier-price-btn">
              <i class="fas fa-plus"></i> Add Price Tier
            </button>
          </div>
        </div>
      </div>
    `;
    
    $('#tour-options-container').append(template);
    updateOptionNumbers();
    
    // Initialize tiered prices for the new option
    const newOption = $(`[data-index="${timestamp}"]`);
    initializeTieredPricesForOption(newOption);
  });
  
  // Remove tour option
  $(document).on('click', '.remove-option-btn', function() {
    const optionItem = $(this).closest('.tour-option-item');
    const optionId = optionItem.find('input[name*="[id]"]').val();
    
    if (optionId) {
      // For existing options, mark for destruction
      optionItem.hide();
      optionItem.find('[required]').removeAttr('required');
      optionItem.append(`<input type="hidden" name="tour[tour_options_attributes][${optionItem.data('index')}][_destroy]" value="1">`);
    } else {
      // For new options, just remove
      optionItem.remove();
    }
    
    updateOptionNumbers();
  });
  
  // Update option numbers and positions
  function updateOptionNumbers() {
    $('.tour-option-item:visible').each(function(index) {
      $(this).find('.option-number').text(index + 1);
      $(this).find('.option-position').val(index);
    });
  }
  
  // Initialize existing options on page load
  $('.tour-option-item').each(function() {
    initializeTieredPricesForOption($(this));
  });
  
  // Initialize sortable for reordering options
  if ($('#tour-options-container').length && typeof Sortable !== 'undefined') {
    new Sortable(document.getElementById('tour-options-container'), {
      animation: 150,
      handle: '.card-header',
      onEnd: function() {
        updateOptionNumbers();
      }
    });
  }
  
  // Show/hide options section on page load based on checkbox state
  if ($('#tour_has_options').is(':checked')) {
    $('#tour-options-section').removeClass('d-none');
  }
});

export default {};
